import React from 'react';
import PropTypes from "prop-types";

import { Helpers } from '../core/src/helpers';
import GiftCardForm from './gift-card-form';

import './gift-card.less';


class GiftCard extends React.Component {

    static propTypes = {
        product: PropTypes.object,
    };

    static defaultProps = {
        product: {}
    }

    state = {
        purchaseOptions: {},
        validate: false,
        hasErrors: true
    }

     static getDerivedStateFromProps(props, state){
        return {
         isGiftCard:  Helpers.isGiftCard(props.product)
        }   
    }

    componentDidMount(){
        const { price, product } = this.props;
        const { isGiftCard } = this.state;
        if(price.regularPrice === "" && product.itemId && isGiftCard){
           this.props.fetchPrices(product.itemId);
        }
    }

    handleChange = (form, hasErrors) =>{
       this.setState({
        purchaseOptions: form,
        hasErrors
       });
    }

    validateForm = (cb) => {
        const { isGiftCard, hasErrors } = this.state;
        if(!isGiftCard){
            cb()
        }else{
            this.setState({
                validate: true
            });
            if(!hasErrors){
                cb();        
            }
        }
    }

    productOptions(items={}){
        return [
        { salePrice: 'Select one' },
        ...Object.keys(items).map((i) => {
                //shallow copy item to avoid side effect
                let item = Object.assign({},items[i]);
                item.salePrice = Helpers.formatCurrency(item.salePrice,'$', true);
                return item;
        }).filter(p => !!p.order).sort((s1,s2) => (s1.order * 1) - (s2.order * 1))]
    }
   
    render() {
        const { product, price } = this.props;
        const { purchaseOptions, validate, hasErrors, isGiftCard } = this.state;
        const { validateForm } = this;

        const giftCardForm = isGiftCard ? 
                (<GiftCardForm 
                items={this.productOptions(price.items)} 
                type={product.prdClass} 
                validate={validate}
                handleChange={this.handleChange}/>) : null;

       


        if(this.props.children){
            return this.props.children({
                isGiftCard,
                giftCardForm,
                purchaseOptions,
                validateForm,
                hasErrors,
            })
        }else{
            return null;
        }
    }
}

export default GiftCard;